import React, { useState } from "react";
import Sidebar from "./sidebar/Sidebar.js";
import { Outlet } from "react-router";
import { getAuthProps } from "../utils/AuthenticationLibrary.js";
import { useEnterKeyNavigation } from "../utils/enterKeyNavigation.js";

const Layout = (props) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Windows-style Enter key: press Enter to move to the next field.
  useEnterKeyNavigation();

  let authDetails = getAuthProps()
  return (
    <div className="layout">
      <div className="layout-inner">
        <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <div className="pagescreen">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
